/* eslint-disable @typescript-eslint/naming-convention */
import { Yeseva } from 'app/fonts';
import classNames from 'classnames';
import PriceList from 'features/pricing/components/price-list';
import type { ReactElement } from 'react';
import React from 'react';
import type { ServiceCategory } from 'types/services';
import { validateString } from 'utils/validate-string';

import styles from './category.module.scss';

interface Props {
  readonly category: ServiceCategory;
  readonly level?: number | undefined;
}

const LEVEL_TO_HEADING: Record<
  number,
  'h2' | 'h3' | 'h4' | 'h5' | 'h6' | undefined
> = {
  1: 'h2',
  2: 'h3',
  3: 'h4',
  4: 'h5',
  5: 'h6',
};

const STARTING_LEVEL = 1;
const subCategoryClass = validateString(styles.subCategory);

function renderCategoryLabel(
  category: ServiceCategory,
  level: number,
): ReactElement {
  const Wrapper = LEVEL_TO_HEADING[level] ?? 'span';

  return (
    <Wrapper
      className={classNames(styles[Wrapper], {
        [Yeseva.className]: level === STARTING_LEVEL,
      })}
    >
      {category.categoryLabel}
    </Wrapper>
  );
}

export default function Category({
  category,
  level = STARTING_LEVEL,
}: Readonly<Props>): ReactElement {
  return (
    <div
      className={classNames({
        [subCategoryClass]: level !== STARTING_LEVEL,
      })}
      key={`price-list-${category._key ?? category.categoryLabel}`}
    >
      {renderCategoryLabel(category, level)}
      <PriceList category={category} level={level} />
    </div>
  );
}
